import React, {useState} from 'react';
import {useParams} from 'react-router-dom';
import {Link} from 'react-router-dom';
import {adminGetAffiliateVendors, adminUpdateVendorAffiliate} from "../../../services/api/admin";
import SearchAndUpdateVendorAffiliateFlagBlock from "../../../components/Admin/Vendors/SearchAndUpdateVendorAffiliateFlagBlock";
import ConfirmationModal from "../../../components/Modal/ConfirmationModal";
import {Search, X} from "react-feather";
import {AdminTable} from "../../../components/Admin/Common/AdminTable";
import {Button, TextInput} from "flowbite-react";

function highlightText(input, text) {
    if (text.length === 0)
        return input;
    const reg = new RegExp(text, 'gi');
    return input.replace(reg, function (str) {
        return `<b>${str}</b>`;
    });
}

const CDN = process.env.REACT_APP_RESIZABLE;
const HAS_AFFILIATE = 0;

const headers = [
    {data: 'ID', classes: ""},
    {data: 'Name', classes: ""},
    {data: 'Logo', classes: ""},
    {data: 'Website', classes: ""},
    {data: 'Enable Affiliate', classes: ""}
]; // Table headers

const AdminVendorAffiliateList = () => {
    const {page, per_page} = useParams();
    const [vendorsFetched, setVendorsFetched] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [vendorsData, setVendorsData] = useState([]);
    const [updateVendor, setUpdateVendor] = useState(null);

    const [vendorPagination, setVendorPagination] = useState({
        per_page: parseInt(per_page, 10) || 10,
        current_page: parseInt(page, 10) || 1,
        total_pages: 1
    });

    const fetchVendors = async (pageNum = null, perPageNum = null, searchTermParam = null) => {
        setVendorsFetched(false);
        try {
            const currentPage = pageNum !== null ? pageNum : vendorPagination.current_page;
            const currentPerPage = perPageNum !== null ? perPageNum : vendorPagination.per_page;
            const currentSearchTerm = searchTermParam !== null ? searchTermParam : searchTerm;

            const {data, meta} = await adminGetAffiliateVendors({
                page: currentPage,
                per_page: currentPerPage,
                term: currentSearchTerm,
                has_affiliate: HAS_AFFILIATE
            });

            const transformedData = data.map((item) => ({
                id: {data: <Link to={"/admin/vendor/" + item.id}>{item.id}</Link>, classes: ""},
                name: {
                    data: <span dangerouslySetInnerHTML={{__html: highlightText(item.name, currentSearchTerm)}}/>,
                    classes: ""
                },
                logo: {
                    data: <img alt={item.slug} width={50} height={50} style={{objectFit: "contain"}}
                               src={`${CDN}/${item.logo}`}/>,
                    classes: "sl-flex sl-justify-center"
                },
                website: {
                    data:
                        <a href={item.website} target="_blank" rel="noreferrer">{item.website}</a>,
                    classes: "sl-w-10"
                },
                removeFlag: {
                    data: !item.has_affiliate ?
                        <X className={"sl-cursor-pointer"} onClick={() => setUpdateVendor(item)}/> : '',
                    classes: "sl-flex sl-justify-center sl-h-10 sl-p-0"
                },
            }));

            setVendorsFetched(true);
            setVendorsData(transformedData);
            setVendorPagination(meta.pagination);

        } catch (e) {
            console.error('Error fetching vendors:', e);
            setVendorsFetched(true);
        }
    }

    const searchVendorsByTerm = () => {
        fetchVendors(1, vendorPagination.per_page, searchTerm);
    }

    const handlePageChange = (newPage) => {
        fetchVendors(newPage, vendorPagination.per_page, searchTerm);
    }

    React.useEffect(() => {
            if (!vendorsData.length && !vendorsFetched)
                fetchVendors().catch(console.error);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [vendorsData, vendorsFetched]);

    React.useEffect(() => {
            setVendorPagination({
                ...vendorPagination,
                current_page: page,
                per_page: per_page,
            })
            setVendorsFetched(false);
            setVendorsData([]);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, per_page]);

    const handleFlagUpdate = async (id, checked) => {
        try {
            await adminUpdateVendorAffiliate(id, checked);
            setSearchTerm("");
            setUpdateVendor(null);
            await fetchVendors(1, vendorPagination.per_page, '');
        } catch (e) {
            console.error('Error updating vendor flag:', e);
        }
    }


    return (
        <div>
            {updateVendor && <ConfirmationModal
                title={`Enable Affiliate feature for : ${updateVendor.name}`}
                message={`Are you sure you want to enable the Affiliate feature for this Vendor?`}
                handleConfirm={() => handleFlagUpdate(updateVendor.id, true)}
                handleClose={() => {
                    setUpdateVendor(null);
                }}
            />}

            <main className="sl-main sl-mt-8">
                <div className="sl-container sl-m-auto sl-my-8">
                    <h1>Vendors</h1>
                    <SearchAndUpdateVendorAffiliateFlagBlock handleFlagUpdate={handleFlagUpdate}/>

                    <div className={"flex flex-row gap-1 sl-mt-8  sl-mb-2"}>
                        <TextInput
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value)
                            }}
                            className={"sl-w-120"}
                            type="text" sizing="md" placeholder={'Enter Vendor name to search ...'}/>

                        <Button size="md" isProcessing={!vendorsFetched} onClick={searchVendorsByTerm} color={"light"}>
                            {vendorsFetched && <Search size={16}/>}
                        </Button>
                    </div>

                    <AdminTable
                        dataFetched={vendorsFetched}
                        headers={headers}
                        data={vendorsData}
                        paginationData={vendorPagination}
                        basePath={`/admin/vendors/affiliate`}
                        paginator={vendorPagination}
                        onPageChange={handlePageChange}
                    />
                </div>
            </main>
        </div>
    );
};

export default AdminVendorAffiliateList;
